import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import storePersist from '../../redux/storePersist'
import { tenantDetails } from '../../request/request'

const AccountSettings = () => {
    const navigate = useNavigate()
    const [openDropdown, setOpenDropdown] = useState(false)

    const handleLogout = () => {
        localStorage.removeItem('access-token')
        localStorage.removeItem('accessTokenMetadata')
        localStorage.removeItem('guestTokenMetadata')
        localStorage.removeItem('userProfile')

        const specificChannel = storePersist?.get("channels")?.current.find(
            (element: any) => element.SalesChannelName === "PCP"
        );
        tenantDetails.SalesChannelName = specificChannel?.SalesChannelName;
        tenantDetails.StoreId = specificChannel?.StoreId;
        tenantDetails.SalesChannelId = specificChannel?.Id;

        storePersist.set("application", "guest")
        window.location.href = "/venture/login"
    }

    const menuItems = [
        { name: "Account", path: "/venture/profile" },
        { name: "Purchase Programs", path: "/venture/purchase-programs" },
        { name: "My Subscriptions", path: "#" }, 
        { name: "Address", path: "/venture/address" },
        { name: "HelpCenter", path: "/venture/helpcenter" },
        { name: "Logout", path: "", onClick: handleLogout },
    ]

    const subscriptionDropdownItems = [
        { name: "IE", path: "/venture/mysubscriptions/ie" },
        { name: "NP", path: "/venture/mysubscriptions/np" },
        { name: "DBaaS", path: "/venture/mysubscriptions/dbaas" },
        { name: "DBNBiz", path: "/venture/mysubscriptions/dbnbiz" },
        { name: "DBN Agent", path: "/venture/mysubscriptions/dbnagent" },
        { name: "DBN Partner", path: "/venture/mysubscriptions/dbnpartner" },

    ]

    return (
        <div className="w-1/4 mt-20 flex flex-col items-center">
            {menuItems.map((item, index) => (
                <div key={index} className="w-full">
                    <li
                        onClick={() => {
                            if (item.name === "My Subscriptions") {
                                setOpenDropdown(!openDropdown)
                            } else if (item.path) {
                                navigate(item.path)
                            } else {
                                item.onClick?.()
                            }
                        }}
                        className="flex items-center justify-start px-10 mx-10 py-3 w-full cursor-pointer hover:bg-gray-100 rounded"
                    >
                        <svg fill="#FFB934" className="w-6 h-6 flex-shrink-0" viewBox="0 0 24 24">
                            <path d="M22,11V7.83L12,2.06,2,7.83V11H4v8H2v2H22V19H20V11ZM4,9l8-4.62L20,9H4ZM6,19V11H8v8Zm4,0V11h4v8Zm8,0H16V11h2Z" />
                        </svg>
                        <span className="ml-2 text-xs uppercase break-words whitespace-normal hover:text-[#FFB934]">
                            {item.name}
                        </span>
                    </li>

                    {/* Dropdown under My Subscriptions with same style */}
                    {item.name === "My Subscriptions" && openDropdown && (
                        <ul className="ml-4">
                            {subscriptionDropdownItems.map((subItem, subIndex) => (
                                <li
                                    key={subIndex}
                                    onClick={() => navigate(subItem.path)}
                                    className="flex items-center justify-start px-10 mx-10 py-3 w-full cursor-pointer hover:bg-gray-100 rounded"
                                >
                                    <svg fill="#FFB934" className="w-6 h-6 flex-shrink-0" viewBox="0 0 24 24">
                                        <path d="M22,11V7.83L12,2.06,2,7.83V11H4v8H2v2H22V19H20V11ZM4,9l8-4.62L20,9H4ZM6,19V11H8v8Zm4,0V11h4v8Zm8,0H16V11h2Z" />
                                    </svg>
                                    <span className="ml-2 text-xs uppercase break-words whitespace-normal hover:text-[#FFB934]">
                                        {subItem.name}
                                    </span>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            ))}
        </div>
    )
}

export default AccountSettings
